import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { useAnalytics, useIdentifyUser } from '@/services/analytics';
import { useAuth } from '@/services/auth';
import { AppRoutes } from '@/utils/types';

export default function () {
    const location = useLocation();
    const params = useSearchParams()[0];
    const { user } = useAuth();
    const mixpanel = useAnalytics();
    const navigate = useNavigate();
    const identifyUser = useIdentifyUser();

    const success = JSON.parse(params.get('success') || 'false');

    useEffect(() => {
        mixpanel?.track('post-checkout', {
            status: 'fetching',
            requestedPlan: params.get('plan'),
            requestedBilling: params.get('billing'),
        });
        if (user) {
            identifyUser(user);
        }
        navigate({
            pathname: AppRoutes.Home,
            ...(success && { search: location.search + '&purchase=success' }),
        });
    }, []);

    return null;
}
